import { Moment } from 'moment';

export interface QuestReportInvoiceRequest {
  companiesIds?: string;
  insurerIds?: string;
  cfopIds?: number;
  customerIds?: string;
  suppliersIds?: string;
  situations?: string;
  cstPisCofins?: string;
  parts: boolean;
  services: boolean;
  consumer: boolean;
  detailItems: boolean;
  startDate: string;
  endDate: string;
}

export enum QuestReportInvoiceSituation {
  authorized,
  replaced,
  processing,
  validated,
  inTyping,
  canceled,
  processingCancellation,
  denied,
}

export enum QuestReportInvoiceTypes {
  partsInvoice = 'PARTS_INVOICE',
  serviceInvoice = 'SERVICE_INVOICE',
  consumerInvoice = 'CONSUMER_INVOICE',
}

export interface QuestReportInvoiceFormValues {
  initialDate: Moment;
  finalDate: Moment;
  companiesIds?: number[];
  insurerIds?: number[];
  cfopIds?: number;
  customerIds?: number[];
  suppliersIds?: number[];
  cstPisCofins?: string;
  detailItems: boolean;
  situations?: QuestReportInvoiceSituation;
  types: QuestReportInvoiceTypes;
}
